import { PathBase } from "@constellation-academy/epic-ui";

export class DocumentsPath extends PathBase {
	static readonly pathKey = "documents";
}
